var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRadarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#1592D2",
    fillOpacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_235_429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 34.5843C29.8455 34.5843 34.5843 29.8456 34.5843 24.0001C34.5843 18.1545 29.8455 13.4158 24 13.4158C18.1545 13.4158 13.4157 18.1545 13.4157 24.0001C13.4157 29.8456 18.1545 34.5843 24 34.5843Z",
    fill: "#6AC3F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 31.5477C28.1685 31.5477 31.5477 28.1685 31.5477 24.0001C31.5477 19.8316 28.1685 16.4524 24 16.4524C19.8315 16.4524 16.4523 19.8316 16.4523 24.0001C16.4523 28.1685 19.8315 31.5477 24 31.5477Z",
    fill: "#BED9FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 27.704C26.0456 27.704 27.7039 26.0457 27.7039 24.0001C27.7039 21.9544 26.0456 20.2961 24 20.2961C21.9544 20.2961 20.2961 21.9544 20.2961 24.0001C20.2961 26.0457 21.9544 27.704 24 27.704Z",
    fill: "#00609B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 13.4158C23.7637 13.4158 23.5294 13.4243 23.2969 13.4396C28.8145 13.8016 33.178 18.3909 33.178 24.0001C33.178 29.6093 28.8145 34.1985 23.2969 34.5605C23.5294 34.5758 23.7637 34.5843 24 34.5843C29.8455 34.5843 34.5843 29.8456 34.5843 24.0001C34.5843 18.1545 29.8455 13.4158 24 13.4158Z",
    fill: "#00609B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 16.4524C23.7629 16.4524 23.5284 16.4639 23.2969 16.4853C27.1356 16.84 30.1414 20.0687 30.1414 24C30.1414 27.9313 27.1356 31.1601 23.2969 31.5148C23.5284 31.5363 23.7629 31.5477 24 31.5477C28.1685 31.5477 31.5477 28.1685 31.5477 24C31.5477 19.8316 28.1685 16.4524 24 16.4524Z",
    fill: "#1592D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0808 20.2981V20.6079C25.3859 21.1806 26.2977 22.4834 26.2977 24C26.2977 25.5166 25.3859 26.8193 24.0808 27.3921V27.7019C26.089 27.6588 27.7039 26.0185 27.7039 24C27.7039 21.9815 26.089 20.3413 24.0808 20.2981Z",
    fill: "#1592D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0022 16.7453C18.2778 16.0803 17.9622 15.3178 17.2972 15.0422C16.6322 14.7665 15.8697 15.0822 15.5941 15.7471C15.3184 16.4121 15.6341 17.1746 16.299 17.4503C16.964 17.7259 17.7265 17.4103 18.0022 16.7453Z",
    fill: "#FDDF7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0215 29.4286C31.5303 28.9198 31.5303 28.0949 31.0215 27.586C30.5127 27.0772 29.6877 27.0772 29.1789 27.586C28.6701 28.0949 28.6701 28.9198 29.1789 29.4286C29.6877 29.9374 30.5127 29.9374 31.0215 29.4286Z",
    fill: "#EF9BBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3711 32.3737C17.8799 31.8649 17.8799 31.0399 17.3711 30.5311C16.8623 30.0223 16.0373 30.0223 15.5285 30.5311C15.0197 31.0399 15.0197 31.8649 15.5285 32.3737C16.0373 32.8825 16.8623 32.8825 17.3711 32.3737Z",
    fill: "#1592D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6484 23.6484H24.3516V12.3516C24.3516 12.1574 24.1942 12 24 12C23.8058 12 23.6484 12.1574 23.6484 12.3516V23.6484H12.3516C12.1574 23.6484 12 23.8058 12 24C12 24.1942 12.1574 24.3516 12.3516 24.3516H23.6484V35.6484C23.6484 35.8426 23.8058 36 24 36C24.1942 36 24.3516 35.8426 24.3516 35.6484V24.3516H35.6484C35.8426 24.3516 36 24.1942 36 24C36 23.8058 35.8426 23.6484 35.6484 23.6484Z",
    fill: "#1592D2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_235_429"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadarIcon);
export default __webpack_public_path__ + "static/media/radarIcon.dad29777d650d3813a4a4b65d95fcf09.svg";
export { ForwardRef as ReactComponent };